import React, { Component } from 'react';
import { partnerApi } from  './../../../API/FetchCall';
import { Notification } from './Notification';
import ReactTooltip from "react-tooltip";
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import { SECONDMENU } from './partnerconstant';
import $ from 'jquery';
class MobilePopMenu extends Component {
  constructor(props) {
    super(props)
    console.log('this.props', this.props)
    this.state = {
      showmenu: false,
      menuList: this.props.menu ? this.props.menu : []
    }
    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }
  componentWillReceiveProps() {

  }
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({
        showmenu: false
      })
    }
  }
  handleMenu = () => {
    this.setState({
      showmenu: true
    })
  }
  handleMenuShow = (e, id) => {
    e.preventDefault();
    $('.tab-panels .tab-panel').css('display', 'none');
    $(`.tab-panels .tab-panel[name="${id}"]`).css('display', 'block');
    let menuList = this.state.menuList.map(item => { item.defaultChecked = (id == item.id); return item; });
    console.log('menuList', menuList);
    this.setState({
      menuList
    })
  }
  render() {
    const { menuList } = this.state;
    let active = this.state.showmenu ? '' : 'hidden';
    return (
      <React.Fragment>
        <nav class={`floating-menu ${active}`} id="sideMenuContainer">
          {menuList.map((item, i) => {
            let clsProp = item.disabled == true ? 'disabled' : item.defaultChecked == true ? 'active' : '';
            return (
              <a href="javascript:;" class={`menuitem ${clsProp}`} onClick={(e) => this.handleMenuShow(e, item.id)}
                dangerouslySetInnerHTML={{ __html: item.name }}></a>
            )
          })}

        </nav>
        <div className="floating-menu-btn" ref={this.wrapperRef} onClick={() => this.handleMenu()}><i className="fa fa-bars" aria-hidden="true"></i></div>
      </React.Fragment>
    )
  }
}

export { MobilePopMenu };



// WEBPACK FOOTER //
// ./src/components/bewise/partners/Common.jsx